module.exports = __webpack_public_path__ + "static/media/mockup-ipad.f6c99d38.jpg";